module.exports = __webpack_public_path__ + "static/media/layout-2.c4f463cb.jpg";